import React, { useState } from 'react';
import { useTranslation, useLocalizedData } from '../i18n';
import './CourseCard.css';

function CourseCard({ course, selected, onSelect }) {
  const { t } = useTranslation();
  const { localize } = useLocalizedData();
  const [selectedDuration, setSelectedDuration] = useState(
    selected ? selected.duration : course.options[0].duration
  );

  const handleSelect = (option) => {
    setSelectedDuration(option.duration);
    onSelect({ ...course, selectedOption: option });
  };

  const isSelected = selected && selected.id === course.id;

  return (
    <div className={`course-card ${isSelected ? 'selected' : ''}`}>
      <div className="course-header">
        <span className="course-icon">{course.icon}</span>
        <div>
          <h3 className="course-name">{localize(course.name)}</h3>
        </div>
      </div>

      <p className="course-desc">{localize(course.description)}</p>

      <div className="course-options">
        {course.options.map((option) => (
          <button
            key={option.duration}
            className={`course-option ${
              isSelected && selectedDuration === option.duration ? 'active' : ''
            }`}
            onClick={() => handleSelect(option)}
          >
            <span className="option-duration">{t('duration_min', { min: option.duration })}</span>
            <span className="option-price">{option.price.toLocaleString()}฿</span>
          </button>
        ))}
      </div>

      {isSelected && <div className="course-check">✓</div>}
    </div>
  );
}

export default CourseCard;
